import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/es';

dayjs.extend(utc);

class utils {
  static formatQuantity(value, decimals) {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(decimals) + 'M';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(decimals) + 'k';
    } else {
      return value;
    }
  }

  static formatPeriod(days) {
    days = parseInt(days);
    if(days<30){
      return "this " + days + " days"
    }else if(days>=30 && days <365){
      return "this " + (days / 30).toFixed(0) + " months"
    }else if(days>=365){
      return "this " + (days / 365).toFixed(0) + " years"
    }
    return days;
  }

  static calculateAge (birthDate) {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const month = today.getMonth();
    const birthMonth = birthDateObj.getMonth();
  
    if (month < birthMonth || (month === birthMonth && today.getDate() < birthDateObj.getDate())) {
      age--;
    }
  
    return age;
  }

  static formatDayMonth(dateStr) {
    if (!dateStr) return '';
    const d = dayjs.utc(dateStr);
    if (!d.isValid()) return dateStr;
    return d.locale('es').format('D [de] MMMM');
  }

  static getFormattedDateInUTC(date) {
    if (!date) return undefined;

    // If it's a string, parse it and convert from UTC to local time
    if (typeof date === 'string') {
      return dayjs.utc(date).format('YYYY-MM-DD HH:mm:ss');
    }

    // If it's a plain object with $d (like a Day.js or MUI date object)
    if (typeof date === 'object' && date.$d) {
      return dayjs.utc(date.$d).format('YYYY-MM-DD HH:mm:ss');
    }

    // Fallback: try to parse directly
    const d = dayjs(date);
    return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : undefined;
  }

  static formatTimeAgo(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = (now - date) / 1000;

    const secondsInMinute = 60;
    const secondsInHour = 3600;
    const secondsInDay = 86400;
    const secondsInWeek = secondsInDay * 7;
    const secondsInMonth = secondsInDay * 30; // approximate
    const secondsInYear = secondsInDay * 365; // approximate

    if (diffInSeconds < secondsInMinute) return "Justo Ahora";
    if (diffInSeconds < secondsInHour) return `Hace ${Math.floor(diffInSeconds / secondsInMinute)} minutos`;
    if (diffInSeconds < secondsInDay) return `Hace ${Math.floor(diffInSeconds / secondsInHour)} horas`;
    if (diffInSeconds < secondsInWeek) return `Hace ${Math.floor(diffInSeconds / secondsInDay)} días`;
    if (diffInSeconds < secondsInMonth) return `Hace ${Math.floor(diffInSeconds / secondsInWeek)} semanas`;
    if (diffInSeconds < secondsInYear) return `Hace ${Math.floor(diffInSeconds / secondsInMonth)} meses`;

    return `hace ${Math.floor(diffInSeconds / secondsInYear)} años`;
  }
}

export default utils;